
export interface IClientListingModel {
    ClientId: string,      //2
    FirstName: string,     //Joe
    LastName: string,      //Jones
    FullName: string       //Jones, Joe,
    AlternatePetParentName: string //Sam,
    EmailAddress: string,  //joejones@gmail.com,
    HomePhone: string,     //123-123-1234
    CellPhone: string,     //123-123-1234
    AlternatePhone: string,//123-123-1234
    Address: string,       //123 Elm St,
    Address2: string,      //Apt 1,
    City: string,          //New York,
    State: string,         //NY,
    LastVisitDate: string | undefined,
    CanCall: boolean,
    CanSMS: boolean,
    IsActive: boolean,
    /* Other fields in search result but not used. */
    //"ExternalSystemName":undefined,
    //"ExternalSystemId":undefined,
    //"ExternalSystemUri":undefined,
    //"@search.score":1.6099695,
    //"IsOKToSMS":true,
    //"PALSNumber":undefined,
    //"IsOKToSMSCellPhone":false,
    //"IsOKToSMSHomePhone":false,
    //"IsOKToSMSAlternatePhone":false,
    //"PGRMasterId":undefined,
    //"ClientIds":[]
}

export class ClientListingModel implements IClientListingModel {
    ClientId: string;
    FirstName: string;
    LastName: string;
    FullName: string;
    AlternatePetParentName: string;
    EmailAddress: string;
    HomePhone: string;
    CellPhone: string;
    AlternatePhone: string;
    Address: string;
    Address2: string;
    City: string;
    State: string;
    LastVisitDate: string | undefined;
    CanCall: boolean;
    CanSMS: boolean;
    IsActive: boolean;

    constructor(params: IClientListingModel) {
        this.ClientId = params.ClientId;
        this.FirstName = params.FirstName;
        this.LastName = params.LastName;
        this.FullName = params.FullName;
        this.AlternatePetParentName = params.AlternatePetParentName;
        this.EmailAddress = params.EmailAddress;
        this.HomePhone = params.HomePhone;
        this.CellPhone = params.CellPhone;
        this.AlternatePhone = params.AlternatePhone;
        this.Address = params.Address;
        this.Address2 = params.Address2;
        this.City = params.City;
        this.State = params.State;
        this.LastVisitDate = params.LastVisitDate;
        this.CanCall = params.CanCall;
        this.CanSMS = params.CanSMS;
        this.IsActive = params.IsActive;
    }
}
